import React from 'react';
import {Link} from "react-router-dom";
import Paragraph, {ParagraphColor, ParagraphWeight} from "../ui/Paragraph";

const HelpPage = () => {
    return (
        <div>
            <Paragraph color={ParagraphColor.BLACK}>
                Довідкова інформація:
                <br/>
                <br/>

                У разі виявлення технічних збоїв або помилок у роботі сайту просимо
                звертатися до відповідального розробника.

                <Paragraph className={'hover:underline decoration-1'}>
                    <Link to='https://t.me/krimson_qq'>ТЕЛЕГРАМ</Link>
                </Paragraph>

                <br/>

                З питань доступу до системи, а також у разі втрати пароля, звертайтесь до системного адміністратора.
                <br/>

                <Paragraph className={'hover:underline decoration-1'}>
                    <Link to='https://t.me/SongOfMoon'>ТЕЛЕГРАМ</Link>
                </Paragraph>
            </Paragraph>
        </div>
    );
};

export default HelpPage;
